export const createError = (element, error) => {
    var errorElement = document.createElement("div");
    errorElement.classList.add('error');
    errorElement.innerHTML = error;
    element.insertAfter(errorElement);
    element.focus();
}

export const removeErrors = () => {
    var ele = document.querySelectorAll(".error");
        
    for (var j = 0; j < ele.length; j++) {
        ele[j].remove();
    }
}